/**
 * NOTE: This class has been separated from the CardClipper class so that the text editor store is only
 *      connected to when its required.
 */
// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import getSelectionRect from '../../../components/editor/domUtils/getSelectionRect';
import { stayedFalse } from '../../../utils/react/propsComparisons';

// Components
import textEditorStoreConnector from '../../../components/editor/store/components/textEditorStoreConnector';
import cardClipperEditorStateManager from './cardClipperEditorStateManager';
import CardClipperTool from './CardClipperTool';

// Styles
import './CardClipper.scss';

const stayedNotClipping = stayedFalse('isClipping');

@textEditorStoreConnector
@cardClipperEditorStateManager
class CardClipperContents extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectionYMidpoint: 0,
        };
    }

    componentDidMount() {
        // This is used when the clip attempt is cancelled / reverted
        if (
            this.props.editorState &&
            this.props.editorState.getSelection() &&
            !this.props.editorState.getSelection().isCollapsed()
        ) {
            // Find the clipper location after the browser gets the chance to render the selection again
            requestAnimationFrame(() => this.findClipperLocation(this.props));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.editorState || !nextProps.editorState) return;

        // Don't update the clipper tool location if we're currently in the process of clipping
        if (
            stayedNotClipping(this.props, nextProps) &&
            this.props.editorState.getSelection() !== nextProps.editorState.getSelection()
        ) {
            this.findClipperLocation(nextProps);
        }
    }

    findClipperLocation = ({ editorState, getContextZoomScale }) => {
        if (!editorState || !editorState.getSelection) return;

        const zoomScale = getContextZoomScale();

        const selection = editorState.getSelection();
        if (selection.isCollapsed()) {
            this.setState({ selectionYMidpoint: 0 });
            return;
        }

        if (!document.activeElement) return;

        // NOTE: If this component ends up being used outside of Cards, this will cause issues.
        // It's purpose is to prevent the clipper from changing location when another text field gets focus
        // such as the hyperlink popup text input
        if (!document.activeElement.closest('.CardEditor')) return;

        const selectionRect = getSelectionRect();
        const containerRect = this.clipperContainerElement.getBoundingClientRect();

        if (!selectionRect || !containerRect) {
            this.setState({ selectionYMidpoint: 0 });
            return;
        }

        const selectionHeight = selectionRect.bottom - selectionRect.top;
        const selectionMidpoint = (selectionRect.bottom + selectionRect.top) / 2;
        // Need to divide by the scale to convert from rendered pixels to unscaled pixels
        const relativeMidpoint = Math.round(selectionMidpoint - containerRect.top) / zoomScale;

        this.setState({ selectionYMidpoint: relativeMidpoint, selectionHeight });
    };

    clipperContainerRef = (c) => {
        this.clipperContainerElement = c;
    };

    render() {
        const { selectionYMidpoint, selectionHeight } = this.state;

        return (
            <div className="CardClipper" ref={this.clipperContainerRef}>
                <CardClipperTool
                    {...this.props}
                    selectionYMidpoint={selectionYMidpoint}
                    selectionHeight={selectionHeight}
                />
            </div>
        );
    }
}

CardClipperContents.propTypes = {
    isClipping: PropTypes.bool,
    isEditing: PropTypes.bool,
    editorState: PropTypes.object,
    getContextZoomScale: PropTypes.func,

    beforeDragStart: PropTypes.func,
};

export default CardClipperContents;
